import { SxProps, Theme } from "@mui/material";

const styles: SxProps<Theme> = [
  {
    "& .button": {
      boxShadow: "none",
      borderRadius: "0",
      minWidth: 40,
      width: 40,
      height: 40,
      padding: 0,
      marginRight: "12px",
      marginBottom: 3,
    },
    "& .infoText": {
      fontWeight: "bold",
      marginBottom: 3,
    },
  },
];

export default styles;
